<template>
  <div class="bodys">
    <div class="login">
      <div class="title">登录</div>
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="账号:" prop="username">
          <el-input v-model="ruleForm.username" type="text" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input v-model="ruleForm.password" :type="passwordType" autocomplete="off">
            <template #suffix>
              <el-icon class="el-input__icon" @click="onChangePwdType">
                <svg-icon :icon="passwordType==='password'?'eye':'eye-open' " />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="验证码:" prop="captcha">
          <el-input v-model="ruleForm.captcha" class="codInpt" type="text" autocomplete="off" @keyup.enter="submitForm(ruleFormRef)" />
          <span class="code" @click="updateCode">
            <el-image :src="captche">
              <template #error>
                <div class="image-slot">
                  <span class="err_info">请刷新验证码</span>
                </div>
              </template>
            </el-image>
          </span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm(ruleFormRef)">确定</el-button>
          <el-button @click="resetForm(ruleFormRef)">重置</el-button>
          <!-- <el-button @click="createPPT">生成PPT</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script setup>
import { reactive, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import PptxGenJS from 'pptxgenjs'

const { proxy } = getCurrentInstance()
const store = useStore()
const router = useRouter()
const ruleFormRef = ref(null)
const captche = ref(`${process.env.VUE_APP_BASE_API}/users/captche?t=${new Date().getTime()}`)
const ruleForm = reactive({
  username: 'admin',
  password: '',
  captcha: ''
})

const submitForm = (formE) => {
  formE.validate(async(valid) => {
    if (!valid) return
    // 调用登录接口
    const data = await store.dispatch('user/login', ruleForm)

    if (data.code === 200) {
      // 调用获取用户信息
      store.dispatch('user/getUserInfo')
      // 跳转路由
      router.go(0)
      router.push('/home/userInfo')
    }
  })
}

const resetForm = (ruleFormRef) => {
  ruleFormRef.resetFields()
  captche.value = `${process.env.VUE_APP_BASE_API}/users/captche?t=${new Date().getTime()}`
}
const updateCode = () => {
  captche.value = `${process.env.VUE_APP_BASE_API}/users/captche?t=${new Date().getTime()}`
}
// 处理密码框文本显示状态
const passwordType = ref('password')
const onChangePwdType = () => {
  if (passwordType.value === 'password') {
    passwordType.value = 'text'
  } else {
    passwordType.value = 'password'
  }
}
const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('密码不能为空'))
  } else {
    callback()
  }
}
const validateUser = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('用户名不能为空'))
  } else {
    callback()
  }
}
const validateCode = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('验证码不能为空'))
  } else {
    callback()
  }
}
const rules = reactive({
  password: [{ validator: validatePass, trigger: 'blur' }],
  username: [{ validator: validateUser, trigger: 'blur' }],
  captcha: [{ validator: validateCode, trigger: 'blur' }]
})
// eslint-disable-next-line
const createPPT = () => {
  // 1. 创建PPT
  const pres = new PptxGenJS()// 2. 创建一个PPT页面，每调用一次 pres.addSlide() 都可以生成一张新的页面
  // 建议把每个页面的构造抽成一个个函数，然后通过函数调用生成新页面，代码不会很乱
  const slide = pres.addSlide()// 3. 调用addTetx()，在PPT页面中插入文字“Hello World from PptxGenJS...”
  // 括号里面是对文字的配置，文字横坐标x为1.5，纵坐标y为1.5，字体颜色 363636……
  // 关于坐标长度与px的转换 x 1 = 127~128px 左右
  slide.addText('Hello World from PptxGenJS...', { x: 1.5, y: 1.5, color: '363636', fill: { color: 'F1F1F1' }, align: 'center'
  })// 4. 生成PPT， 括号中的fileName，就是生成的 PPT名字，可以使用 .then 或者 .catch处理对应事件。
  pres.writeFile({ fileName: 'Sample Presentation.pptx' }).then(() => {
    proxy.$message.success('导出成功')
  })
}

</script>

<style lang="less">
.title {
  font-size: 2em;
  text-align: center;
  line-height: 60px;

}
.login {
  width: 400px;
  height: 300px;
  padding: 15px;
  border: 1px solid #ccc;

  background: #fff;
  border-radius: 3px;
}
.codInpt {
  flex: 1;
}
.code {
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 32px;
  height: 32px;
  cursor: pointer;
}
.err_info {
  margin-left: 25px;
  cursor: pointer;
  color: red;
}
.bodys{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
    background: #1a355b;
}

</style>
